var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['title']},[_c('div',{class:['title-font'],style:('font-size:' +
        _vm.titleObj.titleSize +
        'rem;color:' +
        _vm.titleObj.titleColor +
        ';text-align:' +
        _vm.titleObj.textAlign)},[_vm._v(" "+_vm._s(_vm.titleObj.title)+" ")]),_c('div',{class:['title-line', _vm.titleObj.textAlign],style:('width:' +
        _vm.titleObj.lineWidth +
        'px;height:' +
        _vm.titleObj.lineHeight +
        'px;border-raidus:' +
        _vm.titleObj.lineRadius +
        'px;background-color:' +
        _vm.titleObj.lineColor +
        ';margin-top:' +
        _vm.titleObj.lineMargin +
        'px')})])}
var staticRenderFns = []

export { render, staticRenderFns }